import { get } from "./http"

// ============================================================
// 动态主题 —— 对齐 App 端 Global.themeIntValue 逻辑：
// App 启动时读取缓存 config，再请求 /app/cdb/setting/default 下发
// themeIntValue（如 0xFFFF8800），高 2 位为 alpha，后 6 位为 RGB
// ============================================================

// App: Global.themeIntValue 默认值 0xFFFF8800
const THEME_COLOR_DEFAULT = "#FF8800"
const THEME_STORAGE_KEY = "cdb_theme_color"
const CONFIG_STORAGE_KEY = "cdb_default_config"

// 十六进制 int 值转 #RRGGBB（App: Color(Global.themeIntValue)）
function intToColor(themeIntValue) {
  const hex = Number(themeIntValue).toString(16)
  return "#" + hex.slice(-6).toUpperCase()
}

// 应用主题色到 CSS 变量并缓存
export function applyThemeColor(themeIntValue) {
  const color = themeIntValue ? intToColor(themeIntValue) : THEME_COLOR_DEFAULT
  document.documentElement.style.setProperty("--theme-color", color)
  localStorage.setItem(THEME_STORAGE_KEY, color)
}

// 启动时先用缓存主题色，避免接口返回前闪烁（对齐 App 先读缓存 config）
export function loadThemeColor() {
  const cached = localStorage.getItem(THEME_STORAGE_KEY)
  const color = cached || THEME_COLOR_DEFAULT
  document.documentElement.style.setProperty("--theme-color", color)
}

// 拉取服务端配置并更新主题色（接口与 App 一致：GET /app/cdb/setting/default）
export function fetchThemeColor() {
  let cachedConfig = null
  try {
    cachedConfig = JSON.parse(localStorage.getItem(CONFIG_STORAGE_KEY) || "null")
  } catch (e) {
    cachedConfig = null
  }
  // 有缓存时先应用缓存配置（对齐 App intiAppConfig 逻辑）
  if (cachedConfig && cachedConfig.themeIntValue) {
    applyThemeColor(cachedConfig.themeIntValue)
  }
  return new Promise(resolve => {
    get(
      "cdb/setting/default",
      {},
      resp => {
        if (resp && resp.data) {
          localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(resp.data))
          if (resp.data.themeIntValue) {
            applyThemeColor(resp.data.themeIntValue)
          }
          resolve(resp.data)
          return
        }
        resolve(null)
      },
      () => resolve(null)
    )
  })
}
